import React from 'react'
import './ui.css'

/**
 * Обёртка таблицы: рамка + тулбар + таблица + пагинация.
 * Используйте классы ds-table-toolbar, ds-data-table и т.д. внутри или через children.
 */
function TableShell ({ children, className = '' }) {
  return <div className={`ds-table-shell ${className}`.trim()}>{children}</div>
}

export default TableShell
